import { makeAutoObservable } from 'mobx';
import { GeneInfo } from './types';

export enum StatusTypes {
  Inducible = 'Inducible',
  NonInducible = 'Non Inducible',
  Constitutive = 'Constitutive',
}

export type StatusType =
  | StatusTypes.Inducible
  | StatusTypes.NonInducible
  | StatusTypes.Constitutive;

type GeneState = {
  status: StatusType;
  superscript: string;
};

interface IGene {
  defaultState: GeneState;
  info: GeneInfo;
  state: GeneState;
  states: GeneState[];
  reset: () => void;
  toggle: () => void;
}

export default class Gene implements IGene {
  defaultState: GeneState;
  info: GeneInfo;
  state: GeneState;
  states: GeneState[];

  constructor(
    info: GeneInfo,
    states: GeneState[],
    defaultStateIdx: number = 0
  ) {
    makeAutoObservable(this);

    this.info = info;
    this.states = states;
    this.defaultState = this.state = this.states[defaultStateIdx];
  }

  update = (geneState: GeneState) => {
    const state = this.states.find((s) => s.status === geneState.status);

    if (!state) {
      throw new Error(
        `Invalid GeneState: ${geneState} isn't found in ${this.states}`
      );
    }

    this.state = geneState;
  };

  reset = () => (this.state = this.defaultState);

  toggle = () => {
    const idxCurr = this.states.indexOf(this.state);
    const isEnd = idxCurr === this.states.length - 1;
    const idxTarget = isEnd ? 0 : idxCurr + 1;
    this.state = this.states[idxTarget];
  };
}
